// extracted by mini-css-extract-plugin
export default {"link":"PjFYhFltGYjURztt9tXf","total-count-link":"hMcrtoSK0rZDfLjf05B5"};